import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UpdateRegistrationPersonalPage } from './update-registration-personal';

import { IonicSelectableModule } from 'ionic-selectable';
import { BrMaskerModule } from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    UpdateRegistrationPersonalPage,
  ],
  imports: [
    IonicPageModule.forChild(UpdateRegistrationPersonalPage),
    IonicSelectableModule,
    BrMaskerModule,
  ],
  exports: [
    UpdateRegistrationPersonalPage
  ]
})
export class UpdateRegistrationPersonalPageModule { }



// WEBPACK FOOTER //
// ./src/pages/update-registration-personal/update-registration-personal.module.ts